import i18n from '../R/string/i18n';

export interface CountriesType {
  value: string;
  label: string;
}

const countries = (): CountriesType[] => [
  { value: 'japan', label: i18n.japan() },
  { value: 'south_korea', label: i18n.southKorea() },
  { value: 'china', label: i18n.china() },
  { value: 'taiwan', label: i18n.taiwan() },
  { value: 'hong_kong', label: i18n.hongKong() },
  { value: 'thailand', label: i18n.thailand() },
  { value: 'singapore', label: i18n.singapore() },
  { value: 'malaysia', label: i18n.malaysia() },
  { value: 'indonesia', label: i18n.indonesia() },
  { value: 'philippines', label: i18n.philippines() },
  { value: 'vietnam', label: i18n.vietnam() },
  { value: 'myanmar', label: i18n.myanmar() },
  { value: 'india', label: i18n.india() },
  { value: 'sri_lanka', label: i18n.sriLanka() },
  { value: 'bangladesh', label: i18n.bangladesh() },
  { value: 'israel', label: i18n.israel() },
  { value: 'turkey', label: i18n.turkey() },
  { value: 'uae', label: i18n.unitedArabEmirates() },
  { value: 'saudi_arabia', label: i18n.saudiArabia() },
  { value: 'oman', label: i18n.oman() },
  { value: 'bahrain', label: i18n.bahrain() },
  { value: 'qatar', label: i18n.qatar() },
  { value: 'kuwait', label: i18n.kuwait() },
  { value: 'macau', label: i18n.macau() },
  { value: 'mongolia', label: i18n.mongolia() },
  { value: 'other_asia', label: i18n.otherAsia() },
  { value: 'united_kingdom', label: i18n.unitedKingdom() },
  { value: 'france', label: i18n.france() },
  { value: 'germany', label: i18n.germany() },
  { value: 'italy', label: i18n.italy() },
  { value: 'spain', label: i18n.spain() },
  { value: 'russia', label: i18n.russia() },
  { value: 'sweden', label: i18n.sweden() },
  { value: 'denmark', label: i18n.denmark() },
  { value: 'norway', label: i18n.norway() },
  { value: 'finland', label: i18n.finland() },
  { value: 'netherlands', label: i18n.netherlands() },
  { value: 'switzerland', label: i18n.switzerland() },
  { value: 'belgium', label: i18n.belgium() },
  { value: 'poland', label: i18n.poland() },
  { value: 'austria', label: i18n.austria() },
  { value: 'portugal', label: i18n.portugal() },
  { value: 'ireland', label: i18n.ireland() },
  { value: 'other_europe', label: i18n.otherEurope() },
  { value: 'united_states', label: i18n.unitedStates() },
  { value: 'canada', label: i18n.canada() },
  { value: 'mexico', label: i18n.mexico() },
  {
    value: 'other_north_central_america',
    label: i18n.otherNorthAndCentralAmerica()
  },
  { value: 'brazil', label: i18n.brazil() },
  { value: 'argentina', label: i18n.argentina() },
  { value: 'chile', label: i18n.chile() },
  { value: 'peru', label: i18n.peru() },
  { value: 'uruguay', label: i18n.uruguay() },
  { value: 'venezuela', label: i18n.venezuela() },
  { value: 'other_south_america', label: i18n.otherSouthAmerica() },
  { value: 'australia', label: i18n.australia() },
  { value: 'new_zealand', label: i18n.newZealand() },
  { value: 'other_oceania', label: i18n.otherOceania() },
  { value: 'egypt', label: i18n.egypt() },
  { value: 'ethiopia', label: i18n.ethiopia() },
  { value: 'kenya', label: i18n.kenya() },
  { value: 'south_africa', label: i18n.southAfrica() },
  { value: 'morocco', label: i18n.morocco() },
  { value: 'other_africa', label: i18n.otherAfrica() },
  { value: 'other', label: i18n.otherCountriesAndRegions() }
];

export default countries;
